import { useSearchParams } from 'react-router-dom';
import Page from '../container/Page';
import Delivery from './Delivery/Delivery';
import { useAppState } from '@/context/appState';
import { useEffect } from 'react';
import BoxBuilder from './PickItems/BoxBuilder/BoxBuilder';
import Menu from './PickItems/Menu/Menu';
import OrderManagementToolbar from '../container/PageHeader/OrderManagementToolbar';

export const ORDER_STEPS = ['choose_type', 'menu', 'customize_box'];

export const Order = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useAppState();
  const currentStep = searchParams.get('step');

  // URL Initialization
  useEffect(() => {
    if (!currentStep) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('step', ORDER_STEPS[1]);
      setSearchParams(newParams, { replace: true });
    }
  }, [currentStep, searchParams, setSearchParams]);

  const handleOrderType = (type: 'shipping' | 'pick_up' | 'catering') => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('type', type);

    if (user?.defaultAddress || type === 'pick_up') {
      newParams.set('step', ORDER_STEPS[1]);
    }
    setSearchParams(newParams, { replace: true });
  };

  // The Flattened Slot Record
  const orderSlots = {
    menu: {
      node: <Menu />,
      header: (
        <OrderManagementToolbar
          title={
            <>
              Curate Your <br />
              <span className="italic font-light">Assortment</span>
            </>
          }
          altText={
            <>
              Begin with a signature vessel or explore our seasonal
              <br /> individual flavors to create a gift as unique as its
              <br />
              recipient.
            </>
          }
        />
      ),
    },
    customize_box: {
      node: <BoxBuilder />,
      variant: 'cream' as const,
    },
    default: {
      node: <Menu />,
      header: (
        <OrderManagementToolbar
          title={
            <>
              Curate Your <br />
              <span className="italic font-light">Assortment</span>
            </>
          }
          altText={
            <>
              Begin with a signature vessel or explore our seasonal
              <br /> individual flavors to create a gift as unique as its
              <br />
              recipient.
            </>
          }
        />
      ),
    },
  };

  return (
    <Page
      variant="primary"
      className="[&_#mobile-order-cta]:hidden"
      sectionClassName="has-[#ttc-menu]:bg-brand-frost has-[#customize-box-bundle]:bg-brand-frost"
    >
      {orderSlots}
    </Page>
  );
};
